import { type FC, lazy } from "react";
import { PermissionRoute } from "../Common/Routing/PermissionRoute";
import { ShopfrontRoutes } from "../Common/Routing/Routing";
import { TitleRoute } from "../Common/Routing/TitleRoute";
import BalanceIndex from "./Balances/BalanceIndex";
import ClassificationIndex from "./Classifications/ClassificationIndex";
import CustomerGroupIndex from "./CustomerGroups/CustomerGroupIndex";
import CustomerIndex from "./Customers/CustomerIndex";
import { Dashboard } from "./Dashboard/Dashboard";
import EnterpriseIndex from "./Enterprise/EnterpriseIndex";
import FourZeroFour from "./Errors/404";
import GiftCardIndex from "./GiftCards/GiftCardIndex";
import MarketingIndex from "./Marketing/MarketingIndex";
import OrdersInvoicesIndex from "./OrdersInvoices/OrdersInvoicesIndex";
import PriceListIndex from "./PriceLists/PriceListIndex";
import ProductIndex from "./Products/ProductIndex";
import RegisterIndex from "./Register/RegisterIndex";
import { ReloadForExternal } from "./ReloadForExternal";
import ReportingIndex from "./Reporting/ReportingIndex";
import SecurityIndex from "./Security/SecurityIndex";
import SettingsIndex from "./Settings/SettingsIndex";
import StockMoreIndex from "./StockMore/StockMoreIndex";
import StocktakesIndex from "./Stocktakes/StocktakesIndex";
import SupplierIndex from "./Suppliers/SupplierIndex";
import TicketIndex from "./Tickets/TicketIndex";
import UtilitiesIndex from "./Utilities/UtilitiesIndex";

const SellScreen = lazy(() => import("./SellScreen/SellScreen"));

const Routes: FC = () => {
    return (
        <ShopfrontRoutes>
            <PermissionRoute
                title="Sell | Shopfront"
                permissions={[ "sell" ]}
                path="/"
                key="sellscreen"
                element={<SellScreen />}
            />
            <TitleRoute
                title="Sell | Shopfront"
                path="/offline"
                key="sellscreen-offline"
                element={<SellScreen />}
            />
            <TitleRoute
                title="User Dashboard | Shopfront"
                path="/dashboard"
                key="dashboard"
                element={<Dashboard />}
            />
            {RegisterIndex()}
            {StockMoreIndex()}
            {ProductIndex()}
            {ClassificationIndex()}
            {SupplierIndex()}
            {OrdersInvoicesIndex()}
            {StocktakesIndex()}
            {CustomerIndex()}
            {CustomerGroupIndex()}
            {PriceListIndex()}
            {BalanceIndex()}
            {GiftCardIndex()}
            {MarketingIndex()}
            {TicketIndex()}
            {ReportingIndex()}
            {SettingsIndex()}
            {UtilitiesIndex()}
            {SecurityIndex()}
            {EnterpriseIndex()}
            <TitleRoute
                path="/oauth/authorize"
                element={<ReloadForExternal message="We're redirecting you to the integration authorisation" />}
            />
            <TitleRoute
                path="/kitchen/bump"
                element={<ReloadForExternal message="We're redirecting you to the kitchen" />}
            />
            <TitleRoute
                path="/kitchen/configuration"
                element={<ReloadForExternal message="We're redirecting you to the kitchen" />}
            />
            <TitleRoute key="404" path="*" element={<FourZeroFour />} />
        </ShopfrontRoutes>
    );
};

export default Routes;
